import axios from 'axios';
import { ApiResponseType, NetworkType } from '../../../types/types';
import {
  CreateWithdrawExplorerRequest,
  CreateWithdrawExplorerVerificationEmailRequest,
  CreateWithdrawPartnerRequest,
  GetWithdrawAvailabilityResponse
} from './Withdraw.types';

export const createWithdrawPartnerAsync = async ({
  amount,
  userWalletId,
  networkType,
  networkCurrencyType
}: CreateWithdrawPartnerRequest) => {
  const { data } = await axios.post(`/user/balance/withdraw/confirm`, {
    amount,
    userWalletId,
    networkType,
    networkCurrencyType
  });

  return data;
};

export const createWithdrawFlipmeAsync = async (
  amount: number,
  networkType: NetworkType,
  networkCurrencyType: string
) => {
  const { data } = await axios.post(`/flipme/withdraw`, {
    amount,
    networkType,
    networkCurrencyType
  });

  return data;
};

export const createWithdrawExplorerAsync = async ({
  amount,
  userWalletId,
  emailCode,
  twoFACode
}: CreateWithdrawExplorerRequest): Promise<ApiResponseType<any>> => {
  const { data } = await axios.post<ApiResponseType<any>>(
    `/explorer/withdraw/confirm`,
    {
      amount,
      userWalletId,
      emailCode,
      twoFACode
    }
  );
  return data;
};

export const createWithdrawExplorerUSDTAsync = async ({
  amount,
  userWalletId,
  emailCode,
  twoFACode
}: CreateWithdrawExplorerRequest): Promise<ApiResponseType<any>> => {
  const { data } = await axios.post<ApiResponseType<any>>(
    `/explorer/gaming-usdt/withdraw/confirm`,
    {
      amount,
      userWalletId,
      emailCode,
      twoFACode
    }
  );
  return data;
};

export const createWithdrawExplorerVerificationEmailAsync = async ({
  amount,
  userWalletId,
  verificationCode
}: CreateWithdrawExplorerVerificationEmailRequest): Promise<
  ApiResponseType<any>
> => {
  const { data } = await axios.post<ApiResponseType<any>>(
    `/explorer/withdraw/confirm`,
    {
      amount,
      userWalletId,
      verificationCode
    }
  );
  return data;
};

export const getWithdrawAvailabilityAsync = async (): Promise<
  ApiResponseType<GetWithdrawAvailabilityResponse>
> => {
  const { data } = await axios.get<
    ApiResponseType<GetWithdrawAvailabilityResponse>
  >(`/user/balance/withdraw/availability`);

  return data;
};
